export default function ThinkingIndicator() {
  return (
    <div className="flex justify-start mb-3">
      <div className="bg-ai-bubble rounded-2xl rounded-bl-md px-5 py-4">
        <div className="flex items-center gap-1.5">
          <span className="w-2 h-2 bg-text-muted rounded-full animate-bounce [animation-delay:0s]" />
          <span className="w-2 h-2 bg-text-muted rounded-full animate-bounce [animation-delay:0.2s]" />
          <span className="w-2 h-2 bg-text-muted rounded-full animate-bounce [animation-delay:0.4s]" />
        </div>
      </div>
    </div>
  )
}
